import * as types from "~/store/news/newsType";

export const getTotalListNews = () => {
  return {
    type: types.GET_TOTAL_LIST_NEWS
  };
};

export const getListNews = page => {
  return {
    type: types.GET_LIST_NEWS,
    page
  };
};

export const getListNewBanners = () => {
  return {
    type: types.LIST_NEWS_BANNERS
  };
};
